import { useQuery } from '@tanstack/react-query';

import { fetchPatientEligibilities } from '../api/eligibilityApi';
import { eligibilityKeys } from './keys';

export function patientEligibilitiesQueryDefinition(patientUserId: string) {
  return {
    queryKey: eligibilityKeys.patientList(patientUserId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPatientEligibilities(patientUserId, signal),
    meta: {
      toast: {
        title: 'Could not load eligibilities',
        description: 'DoseSpot eligibility coverages could not be fetched.',
      },
    },
  } as const;
}

export function usePatientEligibilitiesQuery(patientUserId: string | undefined) {
  return useQuery({
    ...patientEligibilitiesQueryDefinition(patientUserId ?? ''),
    enabled: !!patientUserId,
  });
}
